import React from 'react';
import { Box, Flex, Text } from '@backstage/ui';
import { Entity } from '@backstage/catalog-model';
import { RiFileCopyLine } from '@remixicon/react';
import { stringify } from 'yaml';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';
import { appTranslationRef } from '../../../../core/i18n';
import styles from './entity-inspector.module.css';

interface InspectorYamlProps {
  entity: Entity;
}

export const InspectorYaml = ({ entity }: InspectorYamlProps) => {
  const { t } = useTranslationRef(appTranslationRef);
  const [copied, setCopied] = React.useState(false);
  const yamlContent = stringify(entity);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(yamlContent);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Box>
      <Flex justify="end" className={styles.copyBar}>
        <button
          onClick={handleCopy}
          className={styles.copyButton}
        >
          <RiFileCopyLine size={14} />
          <Text variant="body-x-small" className={styles.copyButtonText}>
            {copied ? t('entityInspector.copied') : t('entityInspector.copyToClipboard')}
          </Text>
        </button>
      </Flex>
      <pre className={styles.codeBlock}>
        {yamlContent}
      </pre>
    </Box>
  );
};
